import { useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { useAuthStore } from "../stores/authStore";
import { ConstantRoutes } from "../core/constantRoutes";
import getConfig from "../config/configUtil";

export const useSignalRBalance = () => {
  const conf = getConfig;
  const { isAuthenticated, token, setBalance } = useAuthStore();

  useEffect(() => {
    // Если не авторизован и нет токена в localStorage - выходим
    if (!isAuthenticated() && !localStorage.getItem("token")) {
      return;
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(conf.BACKEND + ConstantRoutes.clientHub, {
        accessTokenFactory: () => {
          const accessToken = token ?? localStorage.getItem("token");
          return accessToken || "";
        },
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    connection.on("BalanceUpdated", (newBalance: number) => {
      console.log("new balance received: ", newBalance);
      setBalance(newBalance);
    });

    connection.start().catch((err) => {
      console.error("SignalR Connection Error: ", err);
    });

    return () => {
      connection.stop();
    };
  }, [isAuthenticated, token, setBalance]); // Добавляем зависимости
};